import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-paper text-ink flex items-center justify-center px-6">
      <div className="max-w-2xl w-full text-center">
        <p className="eyebrow mb-10">Folio not found &middot; 404</p>
        <h1 className="font-display text-[clamp(4rem,16vw,11rem)] leading-[0.85] tracking-tight">
          The page is
          <br />
          <span className="italic text-saffron">unwritten.</span>
        </h1>
        <p className="font-serif text-ink-soft mt-10 max-w-md mx-auto leading-relaxed">
          Either the address strayed, or the chapter has not yet been transcribed.
          You may return to the table of contents.
        </p>
        <div className="mt-12 flex items-center justify-center gap-6">
          <Link to="/" className="btn-ink">
            Return Home
          </Link>
          <Link to="/blog" className="font-mono text-[12px] tracking-[0.2em] uppercase link-underline text-ink-soft pb-1">
            Read the Blog
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
